import React from 'react';
import './index.css';
// import Home from './Home';
import { Provider as StyletronProvider, DebugEngine } from 'styletron-react';
import { Client as Styletron } from 'styletron-engine-atomic';
import { HashRouter, Route, Switch } from 'react-router-dom';

// @ts-ignore
import { StyleReset, ThemeProvider } from 'atomize';
import YourVote from './YourVotePage';
import Playground from './Playground';
import Home from './Home';
import PlaygroundExtra from './PlaygroundExtra'

const debug =
  process.env.NODE_ENV === "production" ? void 0 : new DebugEngine();

// 1. Create a client engine instance
const engine = new Styletron();

const theme = {
  colors: {
    lightest: '#d5e6f7',
    medium: '#050831'
  },
};

function App() {
  return (
    <>
        <StyletronProvider value={engine} debug={debug} debugAfterHydration>
            <ThemeProvider theme={theme}>
              <React.StrictMode>
                <StyleReset />
                <HashRouter basename={process.env.PUBLIC_URL}>
                  <Switch>
                    <Route path={`/`} exact component={() => <Home />} />
                  </Switch>
                  <Switch>
                    <Route path="/yourvote" exact>
                      <YourVote />
                    </Route>
                  </Switch>
                  <Switch>
                    <Route path={`/playground`} exact component={() => <Playground />} />
                  </Switch>
                  <Switch>
                    <Route path={`/playgroundextra`} exact component={() => <PlaygroundExtra />} />
                  </Switch>
                </HashRouter>
              </React.StrictMode>
            </ThemeProvider>
        </StyletronProvider>
    </>
  )
}

export default App;
